import { useCallback } from 'react';
import { List, Map } from 'immutable';
import { LinkOutlined } from '@ant-design/icons';

import { Link } from 'react-router-dom';
import IconText from '../../common/components/IconText';
import LinkWithTargetBlank from '../../common/components/LinkWithTargetBlank';
import { removeProtocolAndWwwFromUrl } from '../../common/utils';
import ActionsDropdownOrAction from '../../common/components/ActionsDropdownOrAction';
import EventTracker from '../../common/components/EventTracker';

function linkToHrefDisplayPair(link: Map<string, string>) {
  const href = link.get('value') as unknown as string;
  const description = link.get('description');
  const display = description || removeProtocolAndWwwFromUrl(href);
  return [href, display];
}

interface UrlsActionProps {
  urls: List<string>; // TODO: Fix this type. This is wrong, we should read a List of Map objects, not a List of strings
  text?: string;
  icon?: React.JSX.Element;
  trackerEventId: string;
  page: string;
  eventAction?: string;
  isTargetBlank?: boolean;
}

function UrlsAction({
  urls,
  text = 'website',
  icon = <LinkOutlined />,
  trackerEventId,
  page,
  eventAction,
  isTargetBlank = true,
}: UrlsActionProps) {
  const renderUrlsAction = useCallback(
    (url: Map<string, any>, title: string) => {
      // TODO: THIS IS A TEMPORARY FIX TO MAKE THE DATASET LINKS WORK
      let value = url.get('value');
      if (text === 'datasets') {
        value = value.replace(
          'https://www.hepdata.net/record/ins',
          '/data/?q=literature.record.$ref:'
        );
      }
      return (
        <EventTracker
          eventCategory={page}
          eventAction={eventAction || 'Link'}
          eventId={trackerEventId}
        >
          {isTargetBlank ? (
            <LinkWithTargetBlank href={value}>{title}</LinkWithTargetBlank>
          ) : (
            <Link to={value}>{title}</Link>
          )}
        </EventTracker>
      );
    },
    [trackerEventId, page, eventAction, isTargetBlank]
  );

  const renderUrlsDropdownAction = useCallback(
    (url: Map<string, any>) => {
      // TODO: THIS IS A TEMPORARY FIX TO MAKE THE DATASET LINKS WORK
      // eslint-disable-next-line prefer-const
      let [href, display] = linkToHrefDisplayPair(url);
      if (text === 'datasets') {
        href = href.replace(
          'https://www.hepdata.net/record/ins',
          '/data/?q=literature.record.$ref:'
        );
      }
      return {
        key: display,
        label: (
          <span key={href}>
            <EventTracker
              eventCategory={page}
              eventAction={eventAction || 'Link'}
              eventId={trackerEventId}
            >
              {isTargetBlank ? (
                <LinkWithTargetBlank href={href}>{display}</LinkWithTargetBlank>
              ) : (
                <Link to={href}>{display}</Link>
              )}
            </EventTracker>
          </span>
        ),
      };
    },
    [trackerEventId, page, eventAction, isTargetBlank]
  );

  const ACTION_TITLE = <IconText icon={icon} text={text} />;

  return (
    <ActionsDropdownOrAction
      values={urls}
      renderAction={renderUrlsAction}
      renderDropdownAction={renderUrlsDropdownAction}
      title={ACTION_TITLE}
    />
  );
}

export default UrlsAction;
